import { render } from "./ForWeddingVendors.vue?vue&type=template&id=e888818e&scoped=true"
import script from "./ForWeddingVendors.vue?vue&type=script&lang=js"
export * from "./ForWeddingVendors.vue?vue&type=script&lang=js"

import "./ForWeddingVendors.vue?vue&type=style&index=0&id=e888818e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e888818e"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QList from 'quasar/src/components/item/QList.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';import Intersection from 'quasar/src/directives/intersection/Intersection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QPageContainer,QIcon,QBtn,QItem,QItemSection,QItemLabel,QList,QExpansionItem,QCard,QCardSection});qInstall(script, 'directives', {Intersection});
